import * as React from "react";
import { useContext } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Instagram, Language, WhatsApp, Email } from "@mui/icons-material";

import pageStyles from "./styles/channelShortLinksStyles";
import { Store } from "../../hooks/main_store";
import Model from "../../hooks/Model";
import { useChannel } from "services";
import { returnFormatNumber } from "utils/validations";
import ReactPlayer from "react-player";
import { RoutesPaths as Routes } from "pages/routes";
import { useNavigate } from "react-router-dom";

const ChannelShortLinks = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const originLink = urlParams.get("origin");
  const { t } = useTranslation();
  const { state } = useContext(Store);
  const styles = pageStyles();
  const navigate = useNavigate();

  const { recommendedVideos, channelInfo } = useChannel({
    channel: "froin",
  });

  const mainVideo = recommendedVideos
    .map((value) => ({ ...value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)[0];

  const getEvents = async () => {
    try {
      // Model.setData("loading", !(state?.events?.length > 0));
      // await EventsService.getEvents();

      if (originLink === "invitation" && false) {
        Model.setData("dialog", {
          open: true,
          title: "🎁 Premio desbloqueado",
          text: "Accede a un 50% de descuento en las entradas para nuestro evento este 4 de Octubre.\n\n📸 Escríbenos a [[WhatsApp]] para cualquier solicitud.",
          link: "https://api.whatsapp.com/send?app_absent=0&phone=573012069045&text=Tengo%20una%20solicitud%20&type=phone_number",
          txtRight: "Reclamar premio",
          fnRight: () => {
            Model.setData("dialog", {
              open: false,
            });
            window.open("https://www.froin.club/tetris");
          },
          txtAux: "Entendido",
          fnAux: () => {
            Model.setData("dialog", {
              open: false,
            });
          },
        });
      }

      if (originLink === "1759587690865") {
        Model.setData("dialog", {
          open: true,
          title: "🏆 Pista del tesoro",
          text: 'Has encontrado una pista en Tetris party:\n\n"Tienes que ir a Instagram ..."\n\nSigue completando la frase con otras pistas',
          txtRight: "Listo",
          fnRight: () => {
            Model.setData("dialog", {
              open: false,
            });
          },
        });
      }

      if (originLink === "1759589812770") {
        Model.setData("dialog", {
          open: true,
          title: "🏆 Pista del tesoro",
          text: 'Has encontrado una pista en Tetris party:\n\n"... abrir el flayer fijado del evento ..."\n\nSigue completando la frase con otras pistas',
          txtRight: "Listo",
          fnRight: () => {
            Model.setData("dialog", {
              open: false,
            });
          },
        });
      }

      if (originLink === "1759589864637") {
        Model.setData("dialog", {
          open: true,
          title: "🏆 Pista del tesoro",
          text: 'Has encontrado una pista en Tetris party:\n\n"... y comentar la palabra TESORO"\n\nSigue completando la frase con otras pistas',
          txtRight: "Listo",
          fnRight: () => {
            Model.setData("dialog", {
              open: false,
            });
          },
        });
      }
    } catch (e) {
      console.log(t("pages.events.allEvents.errorGetEvents"), e);
    } finally {
      Model.setData("loading", false);
    }
  };

  const goTo = (route: string) => {
    switch (route) {
      case "instagram":
        window.location.href = "https://instagram.com/froin.club";
        break;
      case "website":
        window.location.href = "https://froin.club";
        break;
      case "invest":
        window.location.href = "https://froin.club/invest";
        break;
      case "whatsapp":
        window.location.href = "https://wa.me/573012069045";
        break;
      case "email":
        window.location.href = "mailto:hello@froin.co";
        break;
      case "promo-insta":
        window.location.href =
          "https://www.instagram.com/channel/AbYj3RG-qeDRstGH/?igsh=aHNqb3o0dHppN2Jy";
        break;
      case "youtube":
        window.location.href = "https://www.youtube.com/watch?v=bcw-ur-ojpY";
        break;
      case "landing":
        window.location.href = "https://landing.froin.club";
        break;
      case "riffwin":
        window.location.href = "https://riff.win/catch-leads";
        break;
      case "fravents":
        window.location.href = "https://www.fravents.com/about-us";
        break;
      default:
        navigate(route || Routes.home);
    }
  };

  React.useEffect(() => {
    Model.setData("opacity", 0.7);
    Model.setData("layoutConfig", {
      noheader: true,
      noFooter: true,
      noPadding: true,
    });
    getEvents();
    return () => {};
    //eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.scrollContainer}>
        {channelInfo?.image && (
          <img
            alt="profile"
            className={styles.profileImage}
            src={channelInfo.image}
          />
        )}
        <h1 className={styles.title}>@froin.club</h1>
        <Grid
          container
          wrap="nowrap"
          justifyContent="space-around"
          style={{ paddingBottom: 30 }}
        >
          <Grid item>
            <button
              onClick={() => goTo("website")}
              className={styles.iconSocial}
            >
              <Language />
            </button>
          </Grid>
          <Grid item>
            <button
              onClick={() => goTo("instagram")}
              className={styles.iconSocial}
            >
              <Instagram />
            </button>
          </Grid>
          <Grid item>
            <button
              onClick={() => goTo("whatsapp")}
              className={styles.iconSocial}
            >
              <WhatsApp />
            </button>
          </Grid>
          <Grid item>
            <button onClick={() => goTo("email")} className={styles.iconSocial}>
              <Email />
            </button>
          </Grid>
        </Grid>

        <p className={styles.description}>
          El entretenimiento está cambiando, y nosotros estamos construyendo la
          infraestructura para esa nueva etapa.
          <br />
          <br />
          A través de productos digitales, tecnología blockchain y experiencias
          innovadoras, conectamos artistas, marcas, comunidades e inversionistas
          para impulsar nuevas oportunidades dentro de la industria del
          entretenimiento.
          <br />
          <br />
          Si compartes esta visión, explora nuestros proyectos. Tal vez el
          próximo paso sea construir juntos, <b>no dudes en escribirnos</b>.
        </p>

        <button
          className={styles.buttonLinkWhite}
          onClick={() => goTo("riffwin")}
        >
          {"🤑"} Gana entradas a eventos
        </button>
        <button
          className={styles.buttonLink}
          onClick={() => goTo(Routes.detailVideo)}
        >
          {"👀"} Reproduce y Gana
        </button>
        {mainVideo && false && (
          <button
            className={styles.mainVideo}
            onClick={() => goTo(`${Routes.detailVideo}?id=${mainVideo.id}`)}
          >
            <div className={styles.containerImageMainVideo}>
              {mainVideo?.imageUrl ? (
                <img
                  src={mainVideo.imageUrl}
                  className={styles.imageMainVideo}
                  alt="banner"
                />
              ) : (
                <ReactPlayer
                  url={mainVideo.url}
                  light
                  width="100%"
                  height="100%"
                  playing={false}
                  playIcon={<></>}
                />
              )}
            </div>
            <div className={styles.infoMainVideo}>
              <p className={styles.titleMainVideo}>{mainVideo?.name}</p>
              <p className={styles.descriptionMainVideo}>
                {mainVideo?.description}
              </p>
              <p className={styles.labelMainVideo}>
                Reproduce y gana {returnFormatNumber(mainVideo.limit, 0)} puntos
              </p>
            </div>
          </button>
        )}

        <button
          className={styles.buttonLinkWhite}
          onClick={() => goTo(`landing`)}
        >
          {"🎉"} Nuestra membresía
        </button>
        <button className={styles.buttonLink} onClick={() => goTo(Routes.home)}>
          {"📢"} Quienes somos
        </button>
        <button
          className={styles.buttonLinkWhite}
          onClick={() => goTo("fravents")}
        >
          {"🤝"} Nuestro equipo
        </button>
        {/* <button
          className={styles.buttonLink}
          onClick={() => goTo(`${Routes.welcome}?page=register-artist`)}
        >
          {"🎨"} Artista postúlate aquí
        </button> */}
        {/* <button
          className={styles.buttonLink}
          onClick={() => goTo(`${Routes.welcome}?page=register-commerce`)}
        >
          {"🤝"} Comercio hagamos alianza
        </button> */}
        {/* <button className={styles.buttonLink} onClick={() => goTo("youtube")}>
          {"👀"} Ver charla informativa
        </button> */}
      </div>
      <div className={styles.footer}>
        FROIN by Fravents © 2026 - v. {state.version}
      </div>
    </div>
  );
};

export default ChannelShortLinks;
